import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  border: {
    borderBottom: '2px solid lightgray',
    width: '100%',
  },
  content: {
    paddingTop: theme.spacing(0.5),
    paddingBottom: theme.spacing(0.5),
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    fontWeight: 500,
    fontSize: 22,
    color: 'lightgray',
  },
}));

type Props = {
  children: string;
  color?: string;
  style?: React.CSSProperties;
};

const DividerWithText = (props: Props) => {
  const { children, color, style } = props;
  const classes = useStyles();
  return (
    <div className={classes.container} style={style}>
      <div className={classes.border} style={{ borderColor: color }} />
      <span className={classes.content} style={{ color }}>
        {children}
      </span>
      <div className={classes.border} style={{ borderColor: color }} />
    </div>
  );
};
export default DividerWithText;
